export function isExternalUrl(url) {
  return /^https?:\/\//i.test(url);
}

export function isLovableAdventureUrl(url) {
  if (!url) return false;
  try {
    return new URL(url).hostname.toLowerCase().endsWith('lovable.app');
  } catch (e) {
    return false;
  }
}

export function buildMediaViewUrl(media, network) {
  if (network && network.slug) {
    return `/networks/${network.slug}/media/${media.slug}`;
  }
  return media.url.view;
}
